import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import 'font-awesome/css/font-awesome.min.css';
import App from './components/app/app';
import store from './utils/store';
import { unregister } from './registerServiceWorker';
import { Provider } from 'react-redux';

import moment from 'moment';
import 'moment/locale/pt-br';
import 'react-datepicker/dist/react-datepicker.css';

moment.locale('pt-br');

ReactDOM.render(
    <Provider store={store}>
        <App/>
    </Provider>,
    document.getElementById('root'));

unregister();



// WEBPACK FOOTER //
// ./src/index.js